// extracted by mini-css-extract-plugin
export default {"cameraIcon":"_3sVh4___EditableAsset-module__cameraIcon"};